import ko from "knockout";
import protect from "flow/protect";
import myFlowLocator from "flow/utils/myFlowLocator";
import register from "flow/knockout/register";

ko.bindingHandlers.clickRaw = ko.bindingHandlers.click;

register.overrideKnockoutBinding("click", {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        const newValueAccessor = function () {
            const myFlow = myFlowLocator.getMyFlow(bindingContext.$root);

            if (myFlow.hasOngoingTasks()) {
                return function () {};
            }

            const vm = bindingContext.$data;
            return protect(myFlow, vm, valueAccessor());
        };
        return ko.bindingHandlers.clickRaw.init(
            element,
            newValueAccessor,
            allBindingsAccessor,
            viewModel,
            bindingContext
        );
    }
});

(ko.punches as any).wrappedCallback.enableForBinding("click");
